// extracted by mini-css-extract-plugin
module.exports = {"container":"categories_container__qNGPf"};